import { Icon } from "@zapier/zinnia-icons";
import {
  Button,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";
import { useSetAtom } from "jotai";
import { refreshAssetSetter } from "@zapier/canvas-state";

export default function RefreshAssetButton({
  isLoading,
}: {
  isLoading: boolean;
}) {
  const handleRefreshAsset = useSetAtom(refreshAssetSetter);

  return (
    <Tooltip
      key="refresh-asset-button-tooltip"
      content="Refresh preview"
      placement="top"
      offset="small"
    >
      <TooltipFocusableTrigger>
        <Button
          variant="tertiary"
          size="small"
          iconPosition="start"
          onPress={handleRefreshAsset}
          isDisabled={isLoading}
        >
          <Icon name="arrowRefresh" />
        </Button>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}
